import { InitiativeTab } from "../interfaces/home.interface";

export const CONTROLLER = {
  USER: 'user',
  COMPARE: 'compare',
  CLIENT:'client',
  CHAT:'chat'
};

export const METHOD = {
  USER_DETAILS: 'userdetails',
  PROFILE_PIC:'profilepic',
  HISTORIES:'histories',
  ENGAGEMENTS:'engagements',
  INNOVATION_AND_PRODUCTIVITY:'innovationandproductivity',
  RISK_MANAGEMENT:'riskmanagement',
  TESTIMONIALS:'testimonials',
  REVENUE_MARGINS:'revenuemargins',
  BILLING_DETAIL:'billingdetail',
  HIGHLIGHT_DETAIL:'highlightdetail',
  GOVERNANCE_MEETINGS:'governancemeetings',
  CLIENT_DETAILS:'clientdetails',
  TALENT_MANAGEMENT:'talentmanagement',
  PROMOTION_AND_PROGRESSION:'promotionandprogression',
  HIRING_AND_ATTRITION:'hiringandattrition',
  TRAINING_AND_CERTIFICATION:'trainingandcertification',
  REVENUE_POTENTIAL:'revenuepotential',
  KEYMETRICSLIST:'keymetricslist',
  TRANSITIONLIST:'transitions',
  KEYMETRICSDETAILS:'keymetrics',
  GDSINTEGRATIONDETAILS:'engagements',
  INVOICE:'invoice',
  COUNT: 'count',
  ALL:'all',
  CONTRACTUALDOCSLIST:'contractualdocumentslist',
  CASE_STUDIES: 'casestudies',
  CHATBOTCONVERSATIONS: 'conversations',
  ASSETLIBRARY:'assetlibrary',
  POWERBIWORKSPACE: 'workspace',
  POWERBIREPORT: 'report',
};
export const DOC_TYPES = {
  POLICY: 'Policy and Procedure',
  AGREEMENT: 'Agreement',
  PLAN:'Plan',
  TEMPLATE:'Template',
  REPORT:'Report'
};
export const COMPETENCIES = {
  FINCRIME: 'FinCrime',
  CYBER: 'Cybersecurity',
  TECHOPS:'TechOps',
  HR:'HR managed services',
  FINANCE:'Finance',
  TPRM:'TPRM'
};
export const initiativesTabs:InitiativeTab[] = [
  {
    activeIcon: 'assets/images/inflights_active.svg',
    inActiveIcon: 'assets/images/inflights_inactive.svg',
    name: 'Inflight',
    count: 0,
    active: true,
  },
  {
    activeIcon: 'assets/images/completed_active.svg',
    inActiveIcon: 'assets/images/completed_inactive.svg',
    name: 'Completed',
    count: 0,
    active: false,
  },
];
